import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import Image from 'next/image'
import { type FC } from 'react'

import tailwindPresetScreenSizes from 'tailwind-preset/screens.js'

import { type StoryblokComponentProps } from '../../model'
import { storyAccessorGetBorderRadius } from '../../model/storyAccessors/storyAccessorGetBorderRadius'
import { type StoryblokImageV2Type } from '../../storyblok'

export const StoryblokImageV2: FC<
  StoryblokComponentProps<StoryblokImageV2Type>
> = ({ blok }) => {
  const {
    alt,
    borderRadius,
    fill,
    height,
    heightTablet,
    src,
    srcTablet,
    width,
    widthTablet,
  } = blok

  const borderClasses = borderRadius
    ? storyAccessorGetBorderRadius(borderRadius)
    : undefined

  if (!src) {
    return null
  }

  if (fill) {
    return (
      <Image
        alt={alt}
        className={clsx('object-contain', borderClasses)}
        fill
        src={src}
        unoptimized
      />
    )
  }

  return (
    <picture {...storyblokEditable(blok)}>
      {srcTablet ? (
        <source
          height={Number(heightTablet) || undefined}
          media={`(min-width: ${tailwindPresetScreenSizes.tablet})`}
          srcSet={srcTablet}
          width={Number(widthTablet) || undefined}
        />
      ) : null}
      {/*
      Use `img` tag to support optional `width` & `height` attributes
      always required for Next.js `Image` component (when `fill` is not set),
      it's a temporary workaround for better UX to not enforce people provide
      original image size. Using Storyblok Assets management or
      Celum integration could resolve the issue in the future.
       */}
      <img
        alt={alt}
        className={borderClasses}
        decoding="async"
        height={Number(height) || undefined}
        loading="lazy"
        src={src}
        width={Number(width) || undefined}
      />
    </picture>
  )
}
